<template>
  <section v-if="isNotAnEmployee && route.name !== 'Gift Card'">
    <WCDesktopOTSwitcher v-if="orderTypesEnabled" />
    <WCDesktopSubNavbar :wcHeaderHeight="wcHeaderHeight" />
  </section>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { useRoute } from 'vue-router';
import { configurationKey } from '@/injections';
import useEmployee from '@/modules/employee/composables/useEmployee';
import WCDesktopOTSwitcher from '@/components/WCDesktopOTSwitcher/WCDesktopOTSwitcher.vue';
import WCDesktopSubNavbar from '../WCDesktopSubNavbar/WCDesktopSubNavbar.vue';

interface Props {
  wcHeaderHeight?: string;
}

withDefaults(defineProps<Props>(), { wcHeaderHeight: '0px' });

const route = useRoute();
const { isNotAnEmployee } = useEmployee();
const configuration = inject(configurationKey);

const orderTypesEnabled = computed(() => configuration?.orderTypesEnabled);
</script>
